
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FilterContainer extends Vue {
  @Prop() label!: string;
  @Prop() isCondensed!: boolean;
}
